import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const CancellationTab = (initialTabLabel: any) => {
    const router = useNavigate();

    const [actions, setActions] = useState<any>([]);

    const HRitems: MenuItem[] = [
        {
            label: 'Registration Cancellation',
            command: () => {
                router('/app/letters/register-cancellation');
            }
        },
        {
            label: 'Application Cancellation',
            command: () => {
                router('/app/letters/application-cancellation');
            }
        },
        {
            label: 'Warning Letter',
            command: () => {
                router('/app/letters/warning-letter');
            }
        },
        {
            label: 'Submission Letter',
            command: () => {
                router('/app/letters/submission-letter');
            }
        },
        {
            label: 'Wrong Affidavit Letter',
            command: () => {
                router('/app/letters/wrong-affidavit-letter');
            }
        },
        {
            label: 'False&Fake',
            command: () => {
                router('/app/letters/false-and-fake');
            }
        },
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    const filteredHRitems = HRitems.filter((item) => item.label && Object.prototype.hasOwnProperty.call(actions, item.label));

    // use Effect method
    useEffect(() => {
        setActions(getAction('Cancellation Letters'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab " />
        </>
    );
};
